(() => {
  const VOL = "fh.vol";
  const KEY = [70, 72, 118, 57, 46, 107, 112, 97, 99, 107].map((n) => String.fromCharCode(n)).join("");
  const H = {
    t0: "d62b5ffffc6011b516ea7579c13ee6c43fbc9ef1b1a2b6e62020313609de7cf0",
    t1: "2e5fe9d03eb453cd5a7f673ac10915bbea0a88dc5238b1e7ea01475ce59e024b",
    t2: "dabdb1c5ab0e70938f585224b882733cf70f06c6bad2aecb47b96dd1f9f6918c",
    t3: "14f3a1621c76f8d25c9bb125e9f5d3087b363b0639e9ebc02a17ba696cb3c15f",
    t4: "207e2c79a5a0f4150d3b690ac9f0596582c057442ca7dc51970c2e96e04ff254",
    t5: "ee4ff86a736d52d963767a02d731747b18a3287a3ff303c08b194fc93c503249",
    t6: "2fe528e04d00324953a2cd72d6d3eefe1cce8ea1db26b81441251ce1a7775622",
    t7: "f3d3657dfbe134444be2a7c31ec480f6db90f3a87731f253e86603d1007cc744",
    t8: "7dd8e1f5724f176a5d21a57285fbecbec21175075f810b08573e447fe88074dd",
    t9: "f063b65a051bb644ddba21bd6556e4e3d55eeae687ef2a7232b6251ec48cfe67",
    t10: "08aab5ed13cd29474630784bd2369eb44a599cf769e91a55fb256dc4c4f4aab8",
    a1: "18e90814c148fb6bc509d9a0979abd090b7099cb749ac1e3f1e235e83e5b90bb",
    c6: [
      "1156e40ff117a61cc906778c2bbacebf009b38ec0173ede5aa47f2b27b2cf26c",
      "d584cd5e061ef8f4ce512912e2bda8a409bea1773a8294d560627da135e8a2e1",
      "722b6aef1b3dbdf174b3e03f61066678e6d0c6b8b4c4c2dfdf7c9b7ea83ea2be",
      "b693db186c67d22fa3adb2d62bb92f0fe27dc46140f1c85f2f9100d2760266ca"
    ],
    c7: "a2e4297eed9a8014f24a5e8ae22fa8baedfab5be0ee94b330f4c8cde753458d2",
    sy: [
      "10fda8532cb3b2a136c942791e4a0c3b6c793e668d424e24eaf718aa501362c5",
      "991e8729ced22a91064532718f0f4bdde7398a087fdc40b4eb5d01eb9aa6d5f6",
      "2df8a2d8941ec77b398d11218d4b05640021c69e1eb6f72bfcc97560252e6c4c",
      "e7b5752d4cbf7084b629f98d62b06465a5ac4dac6eab7f6a5d4f166740057c7f"
    ],
    rp: "281f8e3a1b09880833903233a8d2f2b1e9e67dc19f2fcac10e045ffb6ffdb00e",
    ad: [
      "a1207d1af488abf730529f53ff94508fdc1a326a8087afed9ff1ca91768a1ddd",
      "357bfe69aa83cb491aaa2044a0863892f6324be10711ce36beff6e0791f078aa"
    ],
    room: {
      vx: "c2461c7c3e9f1453138551cd5911b2bb8a334ac4f9274139eb1d63da5dd6489b",
      dne: "7310bb6c9d5c9b7756e4b2e279471aeb357b8499d7856335180a6dccd5feec5b",
      sides: "876d93051ce172e732465b1cba12be0f8d8e46489f9456df9c9a8aaca0cbcf23",
      poem: "0b0331abea5cb274b2f81e10b9e9c24ec523bbe95266d2ffcd019fc01c1a1990",
      poems: "67ebe358146cca5e72bbbac5d66b84b8ccd30d315f6129cb8e890218efc6bb08"
    },
    clk: [
      "8bce0c5b0b1460dea6919b4760ebd654e6b795c3aee184a7f58f76e2b4400eb2",
      "93d96206bc66e0ca6b1a1c63cb3aacf5329c5eeb6d12a8c9ae7da583097eb989"
    ]
  };
  const P = {
    img: "aX1GDAEdCFUN",
    dne: "aX1GDAEPH0wNBDJlE1daDgI=",
    sides: "aX1GDAEYGQUGGA==",
    poem: "aX1GDAEjKCpQNDIwAg==",
    pdf: "LjwCSV1RX04UHDFmFVBPRRcOFUQ0LRddRwUXEwwEK2cSVk0YXyIqKmsaMmkXXV1RU1x+cCQJHlpHUVNZd3hGCBhGRU8TDyA=",
    v: "MCcaCQAGAFU=",
    a1: "JSA6F0MbQw==",
    a2: "JSAkF0MbQw==",
    w1: "NXlYTk8d",
    w2: "NXpYTk8d",
    w3: "NXtYTk8d",
    im: "LX8YF14FFw==",
    z0: "ZB83cHpLNi4xSw8cWBs=",
    z1: "EiATGV4KAxIUBDQsVlBdSxkPAAQ0OhNaWkVMAxFVDiEYTRRLTBITCih2PnxvOSRdTBg2KRgH",
    z2: "eiwfTw4IHAAQGHtqGUoDGRURAgI0akgzDktQQUNLejhWWkIKAxJeSSk7W05HBS8+AAQ2MVQHZw1QEhoYMi0bGUgCHAQQSy4pAFwOCRUCDAYjaBVWXBkFERcOImRWTUYZFQRDCCklBlZADh4VEEsrPQVNDgkVQREONTwZS0sPSl1MG3hCVhkOS1BBXwN1dj90byw1XUwDdXZ8GQ5LUEFDVy57SG9hIjMkX0Que0gzDktQQUNLeiBFB2MuPS4xMnpnHgoQYVBBQ0tmaEpJDggcABAYe2oZSgMcGQ88NCUnBkAOBANMFAIoFylaQRsJTE4PLyVUB3oEUAMGDC8mVktLCB8XBhk/aBNXWg4CQQoFMidWWkEFAw4PDmZqWUpXGBEFDgIoaCRcXgoZEzwkFWpKFl5VekFDS2Z0WV1HHU4=",
    z3: "Ag04cGsv",
    z4: "Bws1fH04UCYxKggcM30=",
    z5: "AAE4cH0jNSU=",
    z6: "Bww7cGBLMSIgLhUbVn58Kj41Ji9oZlgzazkiLjFRZhozemE9NTM6SxUHI2ttLlAvLD9mDjlsYC96T01FTAs+fG0gOS8kSxURJW1rJl5PTWFMATt4aS5QT01FaGZYFwBLMy4xORMYInxqYSYuKigDaFgXAEVeT01FZgs5a3w+IDUmL0wFM3RhOSlBTUVoZlgXAEszLjE5ExgifGphelJMWGYLOXR+JD4kLT8VaCR8fz45MyZLFA0meGc5"
  };

  const buf2hex = (buf) => [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
  const sha = async (s) => {
    const data = new TextEncoder().encode(s);
    const out = await crypto.subtle.digest("SHA-256", data);
    return buf2hex(out);
  };
  const xor = (b64) => {
    const raw = atob(b64);
    let out = "";
    for (let i = 0; i < raw.length; i++) out += String.fromCharCode(raw.charCodeAt(i) ^ KEY.charCodeAt(i % KEY.length));
    return out;
  };
  const q = (i) => (window.FH && window.FH.q && window.FH.q[i]) || "";
  const readVol = () => {
    try { return JSON.parse(sessionStorage.getItem(VOL) || "null"); }
    catch (_) { return null; }
  };
  const writeVol = (v) => {
    try { sessionStorage.setItem(VOL, JSON.stringify(v)); } catch (_) { /* */ }
  };
  const token = () => (readVol() && readVol().t) || "";
  const setTok = (t) => writeVol({ t });
  const atLeast = (need) => {
    const t = token();
    const order = [H.t0, H.t1, H.t2, H.t3, H.t4, H.t5, H.t6, H.t7, H.t8, H.t9, H.t10];
    return order.indexOf(t) >= order.indexOf(need) && t !== "";
  };
  const labOn = () => {
    try { return new URLSearchParams(location.search).get("lab") === "1"; }
    catch (_) { return false; }
  };
  const clockOk = async () => {
    if (labOn()) return true;
    const d = new Date();
    const mark = [99, 108, 107, 124].map((n) => String.fromCharCode(n)).join("");
    const h = await sha(mark + d.getHours() + String.fromCharCode(124) + d.getMinutes());
    return H.clk.indexOf(h) >= 0;
  };
  const a1norm = (s) => {
    const raw = String(s || "").trim();
    const letters = raw.toLowerCase().replace(/[^a-z]/g, "");
    if (letters && /[a-z]/.test(raw)) {
      return [...letters].map((c) => String(c.charCodeAt(0) - 96)).join("");
    }
    return raw.replace(/\D/g, "");
  };
  const calcNorm = (s) => String(s || "").toLowerCase().replace(/[×x]/g, "*").replace(/\s+/g, "");
  const evalCalc = (s) => {
    if (!s || !/^[0-9.+\-*/]+$/.test(s) || /[+\-*/]{2,}/.test(s) || !/[0-9]/.test(s)) return null;
    const tokens = s.match(/\d+\.?\d*|[+\-*/]/g);
    if (!tokens || !tokens.length) return null;
    const md = [];
    for (let i = 0; i < tokens.length; i++) {
      const t = tokens[i];
      if (t === "*" || t === "/") {
        const a = parseFloat(md.pop());
        const b = parseFloat(tokens[++i]);
        if (!Number.isFinite(a) || !Number.isFinite(b) || (t === "/" && b === 0)) return null;
        md.push(t === "*" ? a * b : a / b);
      } else {
        md.push(t === "+" || t === "-" ? t : parseFloat(t));
      }
    }
    let v = typeof md[0] === "number" ? md[0] : NaN;
    for (let i = 1; i < md.length; i += 2) {
      const n = parseFloat(md[i + 1]);
      if (md[i] === "+") v += n;
      else if (md[i] === "-") v -= n;
      else return null;
    }
    if (!Number.isFinite(v)) return null;
    return String(v);
  };
  const cmdNorm = (s) => String(s || "").trim().toLowerCase().replace(/[“”"'`]/g, "").replace(/\s+/g, " ");
  const gateHash = (stage, guess, tok) => {
    const p = String.fromCharCode(103, 124);
    const s = String.fromCharCode(124);
    return sha(p + stage + s + guess + s + tok);
  };

  const os = () => window.FH && window.FH.os;
  const unknown = () => {
    const img = document.querySelector(".os-bin-file .os-file__over");
    return (img && img.getAttribute("src")) || "";
  };

  const go = (b64) => { location.href = xor(b64); };

  const dropped = (name) => {
    try { return !!(JSON.parse(sessionStorage.getItem("fh.drop") || "{}")[name]); }
    catch (_) { return false; }
  };
  const undrop = (name) => {
    try {
      const d = JSON.parse(sessionStorage.getItem("fh.drop") || "{}");
      delete d[name];
      sessionStorage.setItem("fh.drop", JSON.stringify(d));
    } catch (_) { /* */ }
  };

  const spawnVirus = (force) => {
    if (!force && dropped("virus")) return;
    const api = os();
    if (!api || !api.spawnFile) return;
    api.spawnFile("virus", "VIRUS.exe", unknown());
  };
  const spawnEnter = (force) => {
    if (!force && dropped("enter")) return;
    const api = os();
    if (!api || !api.spawnFile) return;
    api.spawnFile("enter", "ENTER.exe", unknown());
  };

  const makeEnterWin = () => {
    if (document.querySelector('.os-win[data-win="enter"]')) return;
    const w = document.createElement("aside");
    w.className = "os-win";
    w.setAttribute("data-win", "enter");
    w.hidden = true;
    w.innerHTML = `<div class="os-win__bar" data-win-drag><span>C:\\FIVEHEARTS\\ENTER.EXE</span><button type="button" class="os-win__x" data-close-win aria-label="Close">×</button></div><div class="os-win__body" data-enter-body></div>`;
    const host = document.querySelector(".os-wins") || document.body;
    host.appendChild(w);
    if (os() && os().bindWin) os().bindWin(w);
    w.querySelector("[data-close-win]").addEventListener("click", (e) => {
      e.preventDefault();
      os() && os().closeWin(w);
    });
  };

  const fillEnter = () => {
    makeEnterWin();
    const body = document.querySelector("[data-enter-body]");
    if (!body || body.dataset.ready) return;
    body.dataset.ready = "1";
    const row = (i, label) => `<div class="os-enter__row">
      <span class="os-enter__name">${label}</span>
      <button type="button" class="os-win__more os-enter__dl" data-enter-dl="${i}" data-enter-name="${label}">download</button>
    </div>`;
    body.innerHTML = `<p class="os-win__copy">NOT EVERYTHING THAT SPEAKS<br>HAS A VOICE.</p>
      <p class="os-win__copy os-win__copy--dim">readme.txt</p>
      <div class="os-enter__files">
        ${row(3, "0001.wav")}
        ${row(4, "0002.wav")}
        ${row(5, "0003.wav")}
      </div>`;
  };

  const saveAsset = async (url, name) => {
    if (!url || !name) return;
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const href = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = href;
      a.download = name;
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(href), 2500);
    } catch (_) { /* */ }
  };

  const fillRepair = () => {
    const body = document.querySelector("[data-repair-body]");
    if (!body) return;
    body.innerHTML = xor(P.z2);
  };

  const openLaugh = (then) => {
    const api = os();
    if (!api) return;
    const vid = document.querySelector("[data-laugh-vid]");
    if (vid) {
      vid.src = q(0);
      vid.muted = false;
      const goNext = () => {
        vid.pause();
        api.closeWin(document.querySelector('.os-win[data-win="laugh"]'));
        then && then();
      };
      vid.onended = goNext;
      api.openWin("laugh");
      vid.play().catch(() => {});
      setTimeout(goNext, 14000);
    } else then && then();
  };

  const typeSfx = () => {
    if (window.FH && typeof window.FH.playSfx === "function") window.FH.playSfx("type");
  };

  const paintDump = (pre, text) => {
    if (!pre) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const punch = xor(P.z0);
    const body = text.endsWith(punch) ? text.slice(0, -punch.length) : text;
    const tail = text.endsWith(punch) ? punch : "";
    if (reduced) {
      pre.textContent = text;
      pre.scrollTop = pre.scrollHeight;
      return;
    }
    pre.textContent = "";
    let i = 0;
    const pump = () => {
      if (!pre.isConnected) return;
      if (i < body.length) {
        i = Math.min(body.length, i + 36 + Math.floor(Math.random() * 52));
        pre.textContent = body.slice(0, i);
        pre.scrollTop = pre.scrollHeight;
        typeSfx();
        requestAnimationFrame(pump);
        return;
      }
      if (!tail) return;
      let j = 0;
      const type = () => {
        if (!pre.isConnected) return;
        if (j >= tail.length) return;
        j += 1;
        pre.textContent = body + tail.slice(0, j);
        pre.scrollTop = pre.scrollHeight;
        typeSfx();
        setTimeout(type, 85);
      };
      setTimeout(type, 420);
    };
    requestAnimationFrame(pump);
  };

  const dumpWall = async (pre) => {
    if (!pre) return;
    pre.textContent = "";
    try {
      const url = q(6);
      const raw = (await (await fetch(url)).text()).trim();
      paintDump(pre, xor(raw) + "\n\n" + xor(P.z0));
    } catch (_) {
      paintDump(pre, xor(P.z0));
    }
  };

  const runK7 = async () => {
    setTok(H.t7);
    const api = os();
    if (!api) return;
    openLaugh(() => {
      api.openWin("tried");
      setTimeout(() => {
        api.closeWin(document.querySelector('.os-win[data-win="tried"]'));
        api.openWin("cons");
        dumpWall(document.querySelector("[data-cons-log]"));
      }, 6000);
    });
  };

  const trySys = async (line, logEl) => {
    const first = cmdNorm(line).split(" ")[0];
    if (/^(help|\?|cls|clear|dir|ls|cd|chdir|md|mkdir|rd|rmdir|type|cat|echo|copy|xcopy|del|erase|ren|rename|move|tree|attrib|date|time|ver|vol|label|mem|set|path|prompt|title|color|start|exit|ping|ipconfig|systeminfo|tasklist|taskkill|find|findstr|sort|fc|comp|assoc|where|whoami|hostname|net|netstat|nslookup|tracert|arp|route|getmac|print|chkdsk|scandisk|format|shutdown|restart|reboot|subst|verify|break|mode|timeout|more|pause|rem|doskey|notepad|edit|calc|explorer|winver|ftype|pushd|popd|zork|zork\.exe|adventure)$/i.test(first)) {
      return false;
    }
    const variants = [cmdNorm(line), cmdNorm(line).replace(/\s/g, ""), cmdNorm(line).replace(/^\/+/, ""), cmdNorm(line).replace(/^\/+/, "").replace(/\s/g, "")];
    const tok = H.t7;
    for (const g of variants) {
      const h = await gateHash("sy", g, tok);
      if (H.sy.includes(h)) {
        if (!(await clockOk())) {
          if (logEl) logEl.textContent += xor(P.z3) + "\n";
          return true;
        }
        setTok(H.t8);
        if (logEl) logEl.textContent += xor(P.z4) + "\n" + xor(P.z5) + "\n";
        const api = os();
        setTimeout(() => {
          api && api.closeWin(document.querySelector('.os-win[data-win="cons"]'));
          api && api.closeWin(document.querySelector('.os-win[data-win="cmd"]'));
          undrop("enter");
          spawnEnter(true);
        }, 700);
        return true;
      }
    }
    return false;
  };

  const tryAdmin = async (line, logEl) => {
    if (!atLeast(H.t9)) return false;
    const g = cmdNorm(line);
    const h = await gateHash("ad", g, H.t9);
    if (!H.ad.includes(h)) return false;
    setTok(H.t10);
    const lines = xor(P.z6).split("\n");
    if (!logEl) return true;
    logEl.textContent += "\n";
    let i = 0;
    const tick = () => {
      if (i < lines.length) {
        logEl.textContent += lines[i++] + "\n";
        logEl.scrollTop = logEl.scrollHeight;
        setTimeout(tick, 280);
      }
    };
    tick();
    return true;
  };

  const onCalcEq = async (expr, display) => {
    const n = calcNorm(expr);
    const safe = n.replace(/[^0-9+\-*/.]/g, "");
    const result = evalCalc(safe);
    if (display) display.value = result == null ? "Error" : result;
    const guesses = [n, safe, result, n.replace(/\*/g, "x")].filter(Boolean);
    for (const g of guesses) {
      const h = await gateHash("c6", g, H.t3);
      if (H.c6.includes(h)) {
        setTok(H.t4);
        go(P.dne);
        return;
      }
    }
    for (const g of guesses) {
      const h = await gateHash("c7", g, H.t6);
      if (h === H.c7) {
        runK7();
        return;
      }
    }
  };

  const calcDisplay = () => document.querySelector("[data-calc-display]");
  const applyCalcKey = (k) => {
    const display = calcDisplay();
    if (!display) return;
    if (k === "C") display.value = "";
    else if (k === "=") onCalcEq(display.value, display);
    else display.value += k;
  };

  const onFile = (name, fromEl) => {
    const api = os();
    if (name === "virus") {
      if (!atLeast(H.t1)) return;
      if (document.body.classList.contains("is-storming")) return;
      if (atLeast(H.t2)) {
        api && api.openWin("a1z26", fromEl);
        return;
      }
      if (api && api.stormLaugh) {
        api.stormLaugh(q(0), () => api.openWin("a1z26", fromEl), fromEl);
        return;
      }
      openLaugh(() => api && api.openWin("a1z26", fromEl));
      return;
    }
    if (name === "enter") {
      if (!atLeast(H.t8)) return;
      fillEnter();
      api && api.openWin("enter", fromEl);
    }
  };

  const gate = (name) => {
    if (name === "enter") return atLeast(H.t8);
    if (name === "cons" || name === "tried") return atLeast(H.t7);
    if (name === "repair") return atLeast(H.t9);
    if (name === "a1z26") return atLeast(H.t1);
    if (name === "laugh") return atLeast(H.t1) || atLeast(H.t7);
    return true;
  };

  const bindHouse = () => {
    const api = os();
    document.querySelectorAll("[data-arg]").forEach((el) => {
      if (el._argBound) return;
      el._argBound = true;
      el.addEventListener("click", () => {
        const k = el.getAttribute("data-arg");
        if (k === "bin-virus") api && api.openWin("recover", el);
        if (k === "recover-yes") {
          setTok(H.t1);
          undrop("virus");
          spawnVirus(true);
          api && api.closeWin(document.querySelector('.os-win[data-win="recover"]'));
        }
        if (k === "recover-no") api && api.closeWin(document.querySelector('.os-win[data-win="recover"]'));
      });
    });

    const a1 = document.querySelector("[data-a1-form]");
    if (a1 && !a1._argBound) {
      a1._argBound = true;
      a1.addEventListener("submit", async (e) => {
        e.preventDefault();
        if (!atLeast(H.t1)) return;
        const guess = a1norm(document.querySelector("[data-a1-in]").value);
        const h = await gateHash("a1", guess, H.t1);
        const err = document.querySelector("[data-a1-err]");
        if (h !== H.a1) {
          if (err) {
            if (!err.dataset.ready) {
              err.innerHTML = xor(P.z1);
              err.dataset.ready = "1";
            }
            err.hidden = false;
          }
          const w = document.querySelector('.os-win[data-win="a1z26"]');
          if (w) {
            w.classList.remove("is-poke");
            void w.offsetWidth;
            w.classList.add("is-poke");
          }
          return;
        }
        setTok(H.t2);
        go(P.img);
      });
    }

    const net = document.querySelector("[data-net-form]");
    if (net && !net._argBound) {
      net._argBound = true;
      net.addEventListener("submit", async (e) => {
        e.preventDefault();
        const q = cmdNorm((document.querySelector("[data-net-in]") || {}).value || "");
        const view = document.querySelector("[data-net-view]");
        if (atLeast(H.t8)) {
          const h = await gateHash("rp", q, H.t8);
          if (h === H.rp) {
            setTok(H.t9);
            fillRepair();
            os() && os().openWin("repair");
            return;
          }
        }
        if (view) view.innerHTML = `<p class="os-win__kicker">NO RESULTS</p><p class="os-win__copy">Index empty.</p>`;
      });
    }
  };

  const stampRoom = async () => {
    const parts = location.pathname.replace(/\/+$/, "").split("/").filter(Boolean);
    const handle = (parts[parts.length - 1] || "").toLowerCase();
    if (!handle) return;
    const rh = await sha([114, 111, 111, 109, 124].map((n) => String.fromCharCode(n)).join("") + handle);
    if (rh === H.room.vx && atLeast(H.t1)) setTok(H.t3);
    if (rh === H.room.sides && atLeast(H.t4)) setTok(H.t5);
    if ((rh === H.room.poem || rh === H.room.poems) && atLeast(H.t5)) setTok(H.t6);
    if (rh === H.room.dne) {
      const open = document.querySelector("[data-dne-open]");
      const box = document.getElementById("confirmation");
      if (open && box) open.addEventListener("click", () => { box.hidden = false; });
      document.querySelectorAll("[data-arg-yn]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const k = btn.getAttribute("data-arg-yn");
          if (k === "a") {
            if (!atLeast(H.t4)) return;
            setTok(H.t5);
            go(P.sides);
          } else {
            location.href = xor(P.pdf);
          }
        });
      });
    }
  };

  const sideAud = (k) => document.querySelector(`[data-side-aud="${k}"]`);
  const sideBtn = (k) => document.querySelector(`[data-side-play="${k}"]`);
  const paintSide = (k) => {
    const a = sideAud(k);
    const b = sideBtn(k);
    if (!b || !a) return;
    b.textContent = a.paused ? "▶ PLAY" : "■ STOP";
  };
  document.addEventListener("click", (e) => {
    const dl = e.target.closest("[data-enter-dl]");
    if (dl) {
      e.preventDefault();
      e.stopPropagation();
      const i = Number(dl.getAttribute("data-enter-dl"));
      saveAsset(q(i), dl.getAttribute("data-enter-name"));
      return;
    }
    const calcBtn = e.target.closest("[data-calc]");
    if (calcBtn) applyCalcKey(calcBtn.getAttribute("data-calc"));
    const play = e.target.closest("[data-side-play]");
    const both = e.target.closest("[data-side-both]");
    if (play) {
      const k = play.getAttribute("data-side-play");
      const a = sideAud(k);
      if (!a) return;
      if (a.paused) a.play().catch(() => {});
      else { a.pause(); a.currentTime = 0; }
    }
    if (both) {
      ["L", "R"].forEach((k) => {
        const a = sideAud(k);
        if (!a) return;
        a.currentTime = 0;
        a.play().catch(() => {});
      });
    }
  });
  document.addEventListener("play", (e) => {
    const k = e.target && e.target.getAttribute && e.target.getAttribute("data-side-aud");
    if (k) paintSide(k);
  }, true);
  document.addEventListener("pause", (e) => {
    const k = e.target && e.target.getAttribute && e.target.getAttribute("data-side-aud");
    if (k) paintSide(k);
  }, true);
  document.addEventListener("keydown", (e) => {
    const typed = e.target && e.target.closest && e.target.closest("[data-calc-display]");
    const win = document.querySelector('.os-win[data-win="calc"].is-open.is-front');
    const room = document.body.classList.contains("is-505") && calcDisplay();
    if (!typed && !win && !room) return;
    if (!typed && e.target && e.target.closest && e.target.closest("input, textarea, select")) return;
    const display = typed || calcDisplay();
    if (!display) return;
    if (e.key === "Enter" || e.key === "=") {
      e.preventDefault();
      applyCalcKey("=");
      return;
    }
    if (typed) return;
    if (e.key === "Backspace") {
      e.preventDefault();
      display.value = String(display.value || "").slice(0, -1);
      return;
    }
    if (e.key === "Delete" || e.key === "c" || e.key === "C") {
      e.preventDefault();
      applyCalcKey("C");
      return;
    }
    if (/^[0-9.]$/.test(e.key)) {
      e.preventDefault();
      applyCalcKey(e.key);
      return;
    }
    if (e.key === "+" || e.key === "-" || e.key === "*" || e.key === "/") {
      e.preventDefault();
      applyCalcKey(e.key);
      return;
    }
    if (e.key === "x" || e.key === "X") {
      e.preventDefault();
      applyCalcKey("*");
    }
  });
  document.addEventListener("input", (e) => {
    const d = e.target && e.target.closest && e.target.closest("[data-calc-display]");
    if (!d) return;
    const next = String(d.value || "").replace(/[x×]/gi, "*");
    if (next !== d.value) d.value = next;
  });

  const bootDesk = () => {
    if (document.body.classList.contains("is-505")) return;
    if (atLeast(H.t1)) spawnVirus();
    if (atLeast(H.t8)) {
      spawnEnter();
      fillEnter();
    }
    bindHouse();
  };

  window.FH = window.FH || {};
  window.FH.arg = {
    gate,
    onFile,
    clockOk,
    onCmd: async (line, logEl) => {
      if (await trySys(line, logEl)) return true;
      if (await tryAdmin(line, logEl)) return true;
      return false;
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => { bootDesk(); stampRoom(); });
  } else {
    bootDesk();
    stampRoom();
  }
})();
